import { render, staticRenderFns } from "./Project_view.vue?vue&type=template&id=8b1f922e"
import script from "./Project_view.vue?vue&type=script&lang=js"
export * from "./Project_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports